<template>
  <div class="card-body">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style>
.card-body {
  padding: var(--s-5) var(--s-5);
}
</style>
